module.exports = __webpack_public_path__ + "static/media/zoom.0d1641e7.svg";